<template>
  <div class="resume">
    <div class="resume-editor" ref="editorFrom">
      <div>
        <!-- 工作经历 -->
        <div class="resumeSection">
          <div>
            <h2 class="resumeSection__title">工作经历</h2>
          </div>
          <div class="resumeSection__form">
            <el-form ref="form" :model="form" :rules="rules">
              <el-form-item label="公司名称" prop="companyName">
                <el-input
                  v-model="form.companyName"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
              <el-form-item label="职位名称" prop="jobPosition">
                <el-input
                  v-model="form.jobPosition"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
              <el-form-item label="开始时间" prop="startTime">
                <el-date-picker
                  clearable
                  v-model="form.startTime"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="请选择开始时间"
                  style="width: 100%"
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item label="结束时间" prop="endTime">
                <el-date-picker
                  clearable
                  v-model="form.endTime"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="请选择结束时间"
                  style="width: 100%"
                >
                </el-date-picker>
              </el-form-item>
              <div class="tips">{{ text }}</div>
              <el-form-item prop="workDescription">
                <el-input
                  type="textarea"
                  :rows="12"
                  maxlength="3000"
                  show-word-limit
                  v-model="form.workDescription"
                  placeholder="描述您在岗职位的工作内容或职责范围等~"
                  @input="handleInput"
                ></el-input>
              </el-form-item>
            </el-form>
            <div class="trigger" @click="show">看看别人怎么写</div>
            <div class="superiorityEg" v-if="flag">
              <div class="superiorityEgInner">
                <div class="superiorityTit">
                  <div class="title">{{ experienceEdit[index].label }}</div>
                  <div class="cut" @click="changeText">换一个</div>
                </div>
                <div id="template" class="superiorityContent">
                  {{ experienceEdit[index].text }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div ref="footerAction" class="resumeEditor-footerAction">
      <el-button round @click="$router.push('/resume')">取消</el-button>
      <el-button size="medium" @click="submit" type="primary">保存</el-button>
    </div>
  </div>
</template>

<script>
import { personalInfo, workExperienceCommit } from "@/api/index";
import experienceEdit from "@/helper/data_template.js";
import { Debounce } from "@/helper/utilities.js";
export default {
  name: "resume-experience",
  data() {
    return {
      text: "工作内容描述",
      flag: false,
      index: "0",
      min: "10", //最少字数
      experienceEdit: experienceEdit.experienceEdit,
      form: {
        miniProgramWorkExperienceId: undefined,
        companyName: undefined,
        jobPosition: undefined,
        startTime: undefined,
        endTime: undefined,
        workDescription: undefined
      },
      rules: {
        companyName: [
          { required: true, message: "公司名称不能为空", trigger: "blur" }
        ],
        jobPosition: [
          { required: true, message: "职位名称不能为空", trigger: "blur" }
        ],
        startTime: [
          { required: true, message: "开始时间不能为空", trigger: "blur" }
        ],
        endTime: [
          { required: true, message: "结束时间不能为空", trigger: "blur" }
        ]
      }
    };
  },
  created() {
    let id = this.$route.params.id;
    if (id) {
      this.getPersonalInfo(id);
    }
  },
  methods: {
    getPersonalInfo(id) {
      personalInfo()
        .then(res => {
          if (res.code == 200) {
            if (res.data.reMiniProgramPerson) {
              this.form = res.data.workExperienceList.find(
                item => item.miniProgramWorkExperienceId == id
              );
            }
          }
        })
        .catch(err => {});
    },

    //显示文本模板
    show() {
      this.flag = !this.flag;
    },

    //换文本模板
    changeText() {
      let experienceEdit = this.experienceEdit;
      this.index++;
      if (this.index >= experienceEdit.length) {
        this.index = 0;
      }
    },

    handleInput(event) {
      //获取输入框内容的长度
      let len = parseInt(event.length);
      //最少字数限制
      if (len <= this.min) this.text = "加油，够10个字可以哦!";
      else if (len > this.min) this.text = "越接300个字越容易得满分哦!";
    },

    submit: Debounce(function() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          workExperienceCommit(this.form)
            .then(res => {
              if (res.code == 200) {
                this.$router.go(-1);
                this.$message({
                  showClose: true,
                  message: "保存成功",
                  type: "success"
                });
              } else {
                this.$message({
                  showClose: true,
                  message: res.msg,
                  type: "warning"
                });
              }
            })
            .catch(err => {});
        }
      });
    }, 1000)
  }
};
</script>

<style lang="less" scoped>
.resume {
  margin-bottom: 30px;
}
.resume-editor {
  width: 900px;
  margin: auto;
  padding: 30px 0;
}
.resumeEditor-footerAction {
  width: 900px;
  margin: auto;
  z-index: 33;
  text-align: right;
  &-fix {
    width: 100%;
    background: #fff;
    position: fixed;
    bottom: 0;
    left: 0;

    box-shadow: 0 -2px 10px #eee;
  }
}
.resumeSection {
  padding: 50px 0;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid @border-base-color;

  &__title {
    margin-right: 200px;

    padding-bottom: 3px;
    border-bottom: 2px solid @main-color;
  }
  &__form {
    width: 600px;
    .tips {
      color: #f04d52;
      margin-bottom: 5px;
    }
    .trigger {
      text-align: right;
      color: #f04d52;
    }
    .superiorityEg {
      width: 100%;
      margin-top: 15px;
      margin-bottom: 50px;
      padding: 0 15px;
      box-sizing: border-box;
      z-index: 10;

      .superiorityEgInner {
        position: relative;
        padding: 20px;
        background: rgba(190, 203, 240, 0.1);

        .superiorityTit {
          margin-bottom: 10px;
          padding-bottom: 10px;
          border-bottom: 1px solid #eee5e5;
          overflow: hidden;

          .title {
            float: left;
            font-size: 14px;
          }

          .cut {
            float: right;
            color: #666;
            font-size: 14px;
          }
        }

        .superiorityContent {
          line-height: 1.7em;
          -webkit-user-select: none;
          user-select: none;
          font-size: 14px;
          white-space: pre-wrap;
        }
      }

      .super {
        padding-bottom: 60px;
      }

      .superiorityEgInner:before {
        position: absolute;
        left: 0;
        top: -7px;
        border: 7px solid transparent;
        border-left-color: rgba(190, 203, 240, 0.1);
        content: "";
      }
    }
  }
}
</style>
